import Form, {
    ButtonItem,
    GroupItem,
    SimpleItem,
    RequiredRule,
    EmailRule,
} from 'devextreme-react/form';
import {useSnackbar} from 'notistack';
import React, {useEffect, useRef, useState} from "react";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {auth, db} from "../../../../firebase/Firebase";
import {NotiStackInfo} from "../../../../palette/NotiStackInfo";
import axios from "axios"

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://recover-pwd-web-easi4xatjq-uc.a.run.app/recover-pwd-web'

//const url = 'http://127.0.0.1:8080/recover-pwd-web'

const recoverAccount = {
    email: '',
};


function Recover(props) {

    const {setCreate, setLogin, setRecover} = props

    const {enqueueSnackbar} = useSnackbar();

    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess,
        icon: 'fas fa-key',
        text: 'Enviar solicitud'
    })
    const [space, setSpace] = useState(false)

    const dxForm = useRef(null);

    useEffect(() => {
        const {instance} = dxForm.current
        instance.resetValues()
    }, [])

    const spaceRender = () => {
        return (
            <div>
                {space &&
                <span style={{fontSize: 12, color: 'red'}}>El correo electronico contiene espacios en blanco</span>}
            </div>
        )
    }

    const onValueChanged = () => {
        const str = recoverAccount.email;
        if (str.indexOf(' ') >= 0) {
            setSpace(true)
        } else {
            setSpace(false)
        }
    }

    const onAccountSubmit = async (e) => {
        e.preventDefault();

        setSubmitButton({...submitButton, icon: 'fa fa-spinner fa-spi', disabled: true, text: 'Enviado solicitud..'})

        try {
            let doc = await db.collection('Users')
                .where("userEmail", "==", recoverAccount.email.trim()).get()
                .then((querySnapshot) => {
                    let r;
                    querySnapshot.forEach((doc) => {
                        r = doc.data()
                    });
                    return r
                })

            if (doc) {

                const {companyName, idCompany} = doc

                const dataCompany = await db.collection(companyName).doc(idCompany).get()
                const data = {
                    email: recoverAccount.email.trim(), companyName, logo: dataCompany.data().logo,
                    phone: dataCompany.data().phone, celPhone: dataCompany.data().celPhone
                }

                const result = await axios.post(url, data, {headers: headers})

                console.log(result.data)

                setSubmitButton({...submitButton, icon: 'fas fa-key', disabled: false, text: 'Enviar solicitud'})
                /*auth.sendPasswordResetEmail(recoverAccount.email.trim()).then(function () {
                    NotiStackInfo('Se ha enviado un link para restablecer su contraseña!', 'success', enqueueSnackbar)
                    setSubmitButton({...submitButton, icon: 'fas fa-key', disabled: false, text: 'Enviar solicitud'})
                    setCreate(false)
                    setRecover(false)
                    setLogin(true)
                })*/
            } else {
                NotiStackInfo('No existe un usuario registrado con este correo electrónico!', 'error', enqueueSnackbar)
                setSubmitButton({...submitButton, icon: 'fas fa-key', disabled: false, text: 'Enviar solicitud'})
            }

        } catch (e) {
            console.log(e)
            NotiStackInfo('No existe un usuario registrado con este correo electrónico!', 'success', enqueueSnackbar)
            setSubmitButton({...submitButton, icon: 'fas fa-key', disabled: false, text: 'Enviar solicitud'})
        }
    }

    return (
        <>
            <form action="" onSubmit={onAccountSubmit}>
                <Form
                    ref={dxForm}
                    formData={recoverAccount}
                    readOnly={false}
                    showColonAfterLabel={true}
                    validationGroup="recover"
                >
                    <GroupItem caption="Recuperar contraseña" colCount={1}>
                        <SimpleItem dataField="email" label={{text: 'Ingrese su correo electrónico', location: 'top'}}
                                    editorOptions={{
                                        onValueChanged: onValueChanged,
                                        showClearButton: true,
                                        maxLength: 70
                                    }}>
                            <EmailRule message="Correo electrónico inválido"/>
                            <RequiredRule message="Ingrese el correo electrónico de usuario"/>
                        </SimpleItem>
                        <SimpleItem render={spaceRender}/>
                    </GroupItem>
                    <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                </Form>
            </form>
        </>
    )


}

export default Recover
